import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from './auth.state';

// const getError = (state: ClientLibraryState): any => state.error;

export const selectAuth: MemoizedSelector<object, AuthState> =
  createFeatureSelector<AuthState>('auth');

export const getState = createSelector(selectAuth, (state) => state);

export const getSsoLink = createSelector(selectAuth, (state) => state.ssoLink);

export const isBusy = createSelector(selectAuth, (state) => state.busy);
